<template>
  <b-modal
    id="processing-request-modal"
    v-model="localShow"
    hide-footer
    centered
    :title="requestSent ? 'Request Sent' : 'Request to Process'"
  >
    <!-- Confirmation state -->
    <div v-if="requestSent" class="text-center py-3">
      <i class="fas fa-check-circle fa-3x mb-3" style="color:#28a745;"></i>
      <h5>Request sent!</h5>
      <p class="text-muted">
        Your request has been sent to <strong>{{ requestTarget && requestTarget.full_name }}</strong>.<br />
        They'll be notified by email and in the app.
      </p>
      <b-button class="btn-gold mt-2" @click="goToChat">
        <i class="fas fa-comment-dots mr-1"></i> Open Chat
      </b-button>
      <b-button variant="link" class="mt-2 d-block mx-auto text-muted" @click="localShow = false">
        Close
      </b-button>
    </div>

    <!-- Request form -->
    <div v-else>
      <p class="text-muted mb-3">
        Send a request to <strong>{{ requestTarget && requestTarget.full_name }}</strong> to hold space for a processing session.
      </p>
      <b-form-textarea
        v-model="requestMessage"
        rows="4"
        class="mb-3"
        style="border-color:#d6b674; resize:none;"
      ></b-form-textarea>
      <div class="d-flex justify-content-end" style="gap:10px;">
        <b-button variant="link" class="text-muted" @click="localShow = false">
          Cancel
        </b-button>
        <b-button
          class="btn-gold"
          :disabled="sendingRequest"
          @click="sendProcessingRequest"
        >
          <i v-if="sendingRequest" class="fas fa-spinner fa-spin mr-1"></i>
          <i v-else class="fas fa-paper-plane mr-1"></i>
          Send Request
        </b-button>
      </div>
    </div>
  </b-modal>

</template>


<script>
import axios from "@/axios";

export default {

  props: {
    requestTarget: {
      type: Object,
      required: true
    },
    value: Boolean,
    contractionId: {
      type: [Number, String],
      default: null,
    },
  },

  computed: {
    localShow: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); },
    },
  },

  data() {
    return {
      requestMessage: "Hey, I'm currently contracted and would really appreciate your support to hold space for a process. Are you available now or sometime soon?",
      sendingRequest: false,
      requestSent: false,
    }
  },

  methods: {
    async connectRequest(member) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Send a connection request to ${member.full_name}?`,
        { title: 'Connect', okTitle: 'Send Request', cancelTitle: 'Cancel', centered: true }
      );
      if (!confirmed) return;

      member.connection_status = 'pending';
      try {
        await axios({
          method: 'post',
          url: 'connections',
          data: { target_user_id: member.id },
        });
      } catch (err) {
        console.error('Connection request error:', err);
        member.connection_status = 'none';
      }
    },

    async acceptRequest(member) {
      this.pendingRequests = this.pendingRequests.filter(m => m.id !== member.id);
      this.connections.push({ ...member, connection_status: 'connected' });
      try {
        await axios({
          url: this.$store.state.api_url + 'connectionAccept',
          params: { sender_id: member.id },
        });
      } catch (err) {
        console.error('Accept error:', err);
        this.connections = this.connections.filter(m => m.id !== member.id);
        this.pendingRequests.push({ ...member, connection_status: 'pending_incoming' });
      }
    },

    async sendProcessingRequest() {
      if (!this.requestMessage?.trim()) {
        return;
      }

      this.sendingRequest = true;

      try {
        const response = await axios({
          method: 'post',
          url: 'processingRequest',
          data: {
            target_user_id: this.requestTarget.id,
            message: this.requestMessage.trim(),
            contraction_id: this.contractionId || null,
          },
        });

        if (response.data && response.data.status === 1) {
          this.requestSent = true;
        }
      } finally {
        this.sendingRequest = false;
      }
    },

    goToChat() {
      this.localShow = false;
      if (this.requestTarget) {
        this.$router.push('/chatbox/' + this.requestTarget.id);
      }
    },

  }
}
</script>


<style scoped>

</style>